import { Modal } from "react-bootstrap";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

interface ConfirmAction {
    page: number,
    rowsPerPage: number
}

interface Props {
    isOpen: boolean;
    action: ConfirmAction;
    onCancel: () => void;
    onConfirm: (action: ConfirmAction) => void;
}

export function ConfirmUnsavedModal(props: Props) {

    const { t } = useTranslation();

    return (
        <Modal
            show={props.isOpen}
            onHide={props.onCancel}
            dialogClassName="modal-dialog-centered mw-500px h-auto"
            backdrop="static"
            keyboard={false}
            centered
        >
            <div className="modal-content">
                <div className="modal-header p-6">
                    <h5 className="modal-title">{t('notificationCenter.unsavedModal.title', "Tem certeza?")}</h5>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={props.onCancel}
                    />
                </div>
                <div className="modal-body py-lg-6 px-lg-6">
                    <span className="text-muted">
                        {t('notificationCenter.unsavedModal.message', "Existem informações nesta página que não foram salvas. Tem certeza de que deseja continuar sem salvar?")}
                    </span>
                </div>
                <div className="modal-footer d-flex justify-content-end gap-2">
                    <button className="btn btn-secondary" onClick={props.onCancel}>
                        {t('notificationCenter.unsavedModal.cancel', "Cancelar")}
                    </button>
                    <button className="btn btn-primary" onClick={() => props.onConfirm(props.action)}>
                        {t('notificationCenter.unsavedModal.confirm', "Continuar assim mesmo")}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
